<template>
<!--评议首页-->
<!--  v-infinite-scroll="getFormData"-->
  <div class="review-wrapper"  :infinite-scroll-immediate="false">
<!--      <div class="top-wrapper">-->
    <div class="top-wrapper" :style="{backgroundImage:settingData.skin?'url(' + settingData.skin.skinIndex.data.background + ')':''}">
      <div class="main-title" v-html="formData.title"></div>
      <div class="asst-title" @click="isShowIntroAction = true">活动说明<Icon type="md-information-circle" /></div>
      <div class="stat-info">
        <div class="stat-info-item">
          <span>{{formData.join_total | filterNum}}<em v-if="formData.join_total >= 10000">万</em></span>
          <span>参与数</span>
        </div>
        <div class="stat-info-item">
          <span>{{formData.submit_total | filterNum}}<em v-if="formData.join_total >= 10000">万</em></span>
          <span>评价次数</span>
        </div>
        <div class="stat-info-item">
          <span>{{formData.pv| filterNum}}<em v-if="formData.join_total >= 10000">万</em></span>
          <span>浏览量</span>
        </div>
      </div>
      <div class="timeout-info">
        <div class="timeout-pannel" v-if="settingData.base && settingData.base.day_limit && settingData.base.day_limit[0]&& settingData.base.day_limit[0].start_time">
          <span v-if="formTimerStatus == 1">距活动开始</span>
          <span v-if="formTimerStatus == 2">距活动结束</span>
          <span v-if="formTimerStatus == 3">活动已结束</span>
          <span v-if="formTimerStatus != 3">
          <i>{{diffDate.d}}</i>
          <em>天</em>
          <i>{{diffDate.h}}</i>
          <em>:</em>
          <i>{{diffDate.m}}</i>
          <em>:</em>
          <i>{{diffDate.s}}</i>
        </span>
        </div>
        <div class="timeout-pannel" v-else>
          <span style="margin-left: 0;">活动进行中</span>
        </div>
        <div class="visit-pannel">
          <span>已有{{formData.join_total | filterNum}} <i v-if="formData.join_total >= 10000">万</i>人参与</span>
          <span>
          <em v-for="(t,i) in formData.imgs"
              v-if="i<7"
              :style="{backgroundImage:t?'url(' + t + ')':''}"
          ></em>
        </span>
        </div>
      </div>
    </div>
    <div class="filter-wrap">
      <div class="group-pannel" @click="isShowGroupAction = true">
        <span>{{raterParams.group == '全部' || raterParams.group == '' ?'请选择单位':raterParams.group}}</span>
        <van-icon name="arrow-down" />
      </div>
      <div class="search-pannel">
        <van-icon name="search" />
        <input placeholder="输入参评对象姓名" type="search" @blur="getFormData(false,true)" @change="getFormData(false,true)" @keyup.enter="getFormData(false,true)" @keyup.13="getFormData(false,true)" v-model="raterParams.keyword">
        <div class="search-btn" @click="getFormData(false,true)">搜索</div>
      </div>
    </div>

    <div class="list-empty" v-if="ratersList.length == 0">
      <img src="../../assets/images/review_empty.jpg" alt="">
      <span>请在上方搜索框选择单位<br/>或输入参评对象姓名搜索进行评价！</span>
    </div>
    <ul class="rater-list">
      <li v-for="(rater,i) in ratersList" @click="toDetail(rater,i)">
        <i class="num">编号: {{rater.sort+1 | filterId}}</i>
        <div class="avatar">
          <img :src="rater.avatar" alt="">
        </div>
        <div class="name">
          {{rater.rater}}
        </div>
        <div class="group-duty">
          <span>{{rater.group}}</span>
          <span>{{rater.duty}}</span>
        </div>
        <div class="visit" :class="{'visited':rater.is_ping == 1}">
          {{rater.is_ping == 1?'已评价':'参与评价'}}
        </div>
      </li>
    </ul>







    <reviewLogin ref="reviewLogin"></reviewLogin>

    <!--单位筛选列表面板-->
    <van-action-sheet v-model="isShowGroupAction">
      <van-picker
          show-toolbar
          :columns="groups"
          @confirm="handleFilterGroup"
          @cancel="isShowGroupAction = false"
      />
    </van-action-sheet>

    <van-action-sheet v-model="isShowIntroAction" title="活动说明">
      <div class="intro-action" v-html="formData.desc"></div>
    </van-action-sheet>

  </div>
</template>

<script>
import {formDetail, formSetting, getWechatOpenid} from "../../api/Interface";
import {Dialog} from "vant";
import reviewLogin from  "./review-login"
import wxconfig from '../../utile/wxconfig'
export default {
  name: "review",
  components:{
    reviewLogin,
    [Dialog.Component.name]: Dialog.Component
  },
  mixins:[wxconfig],
  data(){
    return{
      browser: {
        versions: (function () {
          var u = navigator.userAgent,
              app = navigator.appVersion;
          return {
            trident: u.indexOf("Trident") > -1 /*IE内核*/,
            presto: u.indexOf("Presto") > -1 /*opera内核*/,
            webKit: u.indexOf("AppleWebKit") > -1 /*苹果、谷歌内核*/,
            gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1 /*火狐内核*/,
            mobile: !!u.match(/AppleWebKit.*Mobile.*/) /*是否为移动终端*/,
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) /*ios终端*/,
            android: u.indexOf("Android") > -1 ||
                u.indexOf("Linux") > -1 /*android终端或者uc浏览器*/,
            iPhone: u.indexOf("iPhone") > -1 /*是否为iPhone或者QQHD浏览器*/,
            iPad: u.indexOf("iPad") > -1 /*是否iPad*/,
            webApp: u.indexOf("Safari") == -1 /*是否web应该程序，没有头部与底部*/,
            souyue: u.indexOf("souyue") > -1,
            superapp: u.indexOf("superapp") > -1,
            weixin: u.toLowerCase().indexOf("micromessenger") > -1,
            Safari: u.indexOf("Safari") > -1
          };
        })(),
      },
      is_start:false,
      isLoading:false,
      hasMore:true,
      formData:{},
      settingData:{},
      ratersList:[],
      raterParams:{
        page:1,
        pagesize:9999,
        total:0,
        rater_id:'',
        keyword:'',
        rater:'',
        group:''
      },
      // groups:['全部'],
      groups:[],
      isShowGroupAction:false,
      isShowIntroAction:false,
      onSelectGroup:'',
      formTimer:null,
      diffTime:0,
      diffDate:{
        d:'00',
        h:'00',
        m:'00',
        s:'00'
      },
      formTimerStatus:1,//表单开始状态 1未开始 2进行 3结束
    }
  },
  created(){
    // this.getFormData(true,true);
    this.getSettingData(true);
  },
  mounted(){

  },
  filters:{
    filterId(val){
      if(!val){
        return '';
      }else{
        return val>99?val:(val>9?`0${val}`:`00${val}`);
      }

    },
    filterNum(val){
      if(val>=10000){
        return (val/10000).toFixed(1)
      }else{
        return val;
      }
    }
  },
  methods:{
    // 获取设置
    getSettingData(init = false){
      formSetting(this.$route.query.id).then(res=>{
        if(res.state){
          this.settingData = res.data;
          this.$store.commit('settingData',res.data);
          if(res.data.review.not_share){
            this.hideShareMenu();
          }
          if(init){
            this.groups = [...this.groups,...res.data.groups];
          }
          this.checkLogin();
          this.dealFormTimer();
          this.$forceUpdate()
        }
      })
    },
    checkLogin(){
      if(this.$route.query.openid){
        this.$store.commit('saveOpenid',this.$route.query.openid)
        this.$store.commit('updateReviewLogin',true)
        if(this.$route.query.headimgurl){
          this.$store.commit('saveHeaderImg',this.$route.query.headimgurl)
        }else{
          this.$store.commit('saveHeaderImg','')
        }
        // if(!this.$store.state.isReload){
        //   this.$store.commit('isReload',true);
        //   window.location.reload()
        // }else{
        //   this.getFormData(true,true);
        // }

        this.getwxconfig(()=>{
          if(!this.$store.state.isReload){
            this.$store.commit('isReload',true);
            window.location.reload()
          }else{
            this.getFormData(true,true);
          }
        });

      }else{
        if(!this.$store.state.isReviewLogin || this.$store.state.openid ==''){
          if(this.$store.state.settingData.base.review_wechat_login){
            if(this.browser.versions.weixin){
              let params = {
                form_id:this.$route.query.id,
                redirect_url:location.href
              }
              getWechatOpenid(params).then(res=>{
                if(res.state){
                  location.href = res.data;
                }
              })
            }else{
              Dialog.alert({
                message: '请于微信中打开本页面',
              }).then(() => {
                this.getFormData(true,true);
              });
            }
          }else{
            this.$refs.reviewLogin.open();
            if(this.browser.versions.weixin){
              this.getwxconfig(()=>{
                this.getFormData(true,true);
              })
            }else{
              this.getFormData(true,true);
            }
          }
        }else{
          if(this.browser.versions.weixin){
            this.getwxconfig(()=>{
              this.getFormData(true,true);
            })
          }else{
            this.getFormData(true,true);
          }
        }
      }
    },
    // 获取表单信息
    getFormData(init = false,isFlesh = false){
      if(!init || !isFlesh){
        if(this.isLoading) return;
        if(!this.hasMore && !init && !isFlesh) return;
      }
      if(isFlesh) this.raterParams.page = 1;
      let data = {
        form_id: this.$route.query.id,
        keyword:this.raterParams.keyword,
        group:this.raterParams.group,
        page:this.raterParams.page,
        pagesize:this.raterParams.pagesize,
        openid:this.$store.state.openid
      }

      if(this.raterParams.group == '全部') data.group = '';
      this.isLoading = true;
      formDetail(data).then(res=>{
        this.isLoading = false;
        if(res.state){
          if(init){
            this.formData = res.data;
            this.wxready({
              title:res.data.title,
              desc:'欢迎使用云表单~',
              link:`${location.origin}/h5/review?id=${this.$route.query.id}`
            })
          }
          this.is_start = res.is_start;
          if(!this.is_start){
            Dialog.alert({
              message: '活动不在开始时间内',
            }).then(() => {
              // on close
            });
          }
          this.hasMore = res.raters && res.raters.length == this.raterParams.pagesize?true:false;
          if(init){
            this.ratersList = [];
          }else{
            this.ratersList =isFlesh? res.raters:[...this.ratersList,...res.raters];
          }

          this.raterParams.page+=1;

        }else{
          if(res.error == 'notlogin'){
            this.$store.commit('saveOpenid','')
            this.$store.commit('updateReviewLogin',false)
            location.reload();
          }
        }
      })
    },
    toDetail(rater,i){
      if(!this.is_start){
        Dialog.alert({
          message: '活动不在开始时间内',
        }).then(() => {
          // on close
        });
        return;
      }
      this.$router.push({name:'rater',query:{id:this.$route.query.id,rater_id:rater.id}});
    },
    // 处理活动时间区间
    dealFormTimer(){
      if(this.settingData.base && this.settingData.base.day_limit && this.settingData.base.day_limit[0] && this.settingData.base.day_limit[0].start_time){
        let now = new Date().getTime(),
            startTime = new Date(this.settingData.base.day_limit[0].start_time.replace(/-/ig,'/')).getTime(),
            endTime = new Date(this.settingData.base.day_limit[0].end_time.replace(/-/ig,'/')).getTime();
        if(now < startTime){//未开始
          this.formTimerStatus = 1;
          this.diffTime = startTime - now;
          this.setFormTimer();
        }else if(now >= startTime && now < endTime){//进行中
          this.formTimerStatus = 2;
          this.diffTime = endTime - now;
          this.setFormTimer();
        }else if(now > endTime){//已结束
          this.formTimerStatus = 3;
        }
      }
    },
    setFormTimer(){
      if(this.formTimer) clearInterval(this.formTimer);
      this.formTimer = setInterval(()=>{
        if(this.diffTime<=0){
          clearInterval(this.formTimer)
          window.location.reload();
        }else{
          this.diffTime = this.diffTime - 1000;
          let d = parseInt(this.diffTime/ 1000 / 60 / 60 / 24);
          let h = parseInt(this.diffTime/ 1000 / 60 / 60 % 24);
          let m = parseInt(this.diffTime/ 1000 / 60 % 60);
          let s = parseInt(this.diffTime/ 1000 % 60);
          this.diffDate.d = d < 10 ? "0" + d : d;
          this.diffDate.h = h < 10 ? "0" + h : h;
          this.diffDate.m = m < 10 ? "0" + m : m;
          this.diffDate.s = s < 10 ? "0" + s : s;
        }
      },1000)

    },
    handleFilterGroup(item){
      this.raterParams.group = item;
      this.isShowGroupAction = false;
      this.isLoading = false;
      this.getFormData(false,true);
    }
  }
}
</script>

<style scoped lang="scss">
.review-wrapper{
  padding-bottom:40px;
  height: 100vh;
  overflow: auto;
  .top-wrapper{
    width: 100%;
    min-height: 352px;
    background-image:url("http://www.form.test/reviewBg.png");
    background-repeat :no-repeat;
    background-position: top center;
    background-size:100% 100%;
    overflow: hidden;
  }
  .main-title{
    padding:0 16px;
    margin-top:74px;
    line-height: 46px;
    text-align: center;
    font-size: 24px;
    font-weight:650;
    color:#ffffff;
    letter-spacing: 1px;
  }
  .asst-title{
    margin-top:12px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 31px;
    line-height: 31px;
    text-align: center;
    font-size:16px;
    color:#ffffff;
    background: linear-gradient(90deg, rgba(154,182,255,0) 0%, #8CBDFF 53%, rgba(127,196,254,0) 100%);
    border-radius: 13px 0px 13px 0px;
    .ivu-icon-md-information-circle{
      font-size: 16px;
      font-weight: 550;
      margin-left: 2px;
    }
  }
  .stat-info{
    margin-top: 20px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    .stat-info-item{
      margin: 0 20px;
      width: 65px;
      display: flex;
      flex-direction: column;
      justify-items: center;
      align-items: center;
      span{
        text-align: center;
        &:first-child{
          height: 32px;
          line-height: 32px;
          color: #FFFFFF;
          line-height: 32px;
          text-shadow: 0px 1px 2px rgba(0,5,97,0.3);
          font-size: 21px;
          font-weight:600;
          em{
            margin-left: 2px;
            font-style: normal;
            font-size:12px;
          }
        }
        &:last-child{
          font-weight: 400;
          color: #FFFFFF;
          line-height: 17px;
          text-shadow: 0px 1px 2px rgba(0,5,97,0.3);
        }
      }
    }
  }
  .timeout-info{
    padding:0 25px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items:center;
    margin:13px 15px;
    width: 345px;
    height: 83px;
    background:url('../../assets/images/review/timeout_bg.png') no-repeat center/100%;
    .timeout-pannel{
      width: 100%;
      display: flex;
      align-items:center;
      padding-left:32px;
      height: 25px;
      background-image:url('../../assets/images/review/icon_naozhong.png');
      background-repeat: no-repeat;
      background-size: 15px 16px;
      background-position: 4px center;
      span{
        display: flex;
        font-weight: 500;
        color: #FFFFFF;
        font-size:15px;
        &:first-child{

        }
        &:last-child{
          margin-left: 20px;
          font-weight: 400;
          em{
            margin:0 5px;
            font-style: normal;
          }
          i{
            display: block;
            width: 27px;
            height: 22px;
            background: #2861F8;
            border-radius: 4px;
            text-align: center;
          }
        }
      }
    }
    .visit-pannel{
      margin-top: 10px;
      width: 100%;
      display: flex;
      align-items:center;
      padding-left:32px;
      height: 25px;
      background:url('../../assets/images/review/icon_renyuan.png') no-repeat left/22px;
      span{
        display: flex;
        font-weight: 500;
        color: #FFFFFF;
        font-size:15px;
        &:last-child{
          margin-left: 20px;
          em{
            display: block;
            width: 25px;
            height: 25px;
            border-radius: 25px;
            overflow: hidden;
            background-repeat:no-repeat;
            background-size: 25px 25px;
            background-position: center center;
            &:not(:first-child){
              margin-left: -5px;
            }
          }
        }
      }
    }
  }
  .filter-wrap{
    padding:0 16px;
    display: flex;
    justify-content: space-between;
    .group-pannel{
      padding:0 20px;
      width: 120px;
      height: 36px;
      background: rgba(255,255,255,0.3);
      border-radius: 21px;
      border: 1px solid #8EB7FF;
      text-align: center;
      color:#8EB7FF;
      font-size: 13px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span{
        flex:1;
        height: 36px;
        line-height: 36px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .search-pannel{
      padding:0 6px 0 10px;
      width: 210px;
      height: 36px;
      border-radius: 21px;
      border: 1px solid #8EB7FF;
      display: flex;
      align-items: center;
      .van-icon-search{
        width: 15px;
        font-size:16px;
        font-weight: 550;
        color:#8EB7FF;
      }
      input{
        width: 114px;
        margin-left: 8px;
        height: 28px;
        line-height: 28px;
        color:#8EB7FF;
        font-size:13px;
        border:none;
        background: none;
        &::placeholder{
          color:#8EB7FF;
        }
      }
      .search-btn{
        margin-left: 8px;
        width: 42px;
        height: 24px;
        line-height: 24px;
        border-radius: 24px;
        background-color: #8EB7FF;
        color:#ffffff;
        text-align: center;
        font-size:12px;
        font-weight:550;
      }
    }
  }
  .intro-action{
    padding:0 20px 40px;
    line-height: 24px;
    font-size:14px;
  }
  .list-empty{
    margin-top: 40px;
    padding:0 30px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    font-size:14px;
    img{
      width: 200px;
    }
    span{
      color:#939BAB;
      font-size:16px;
      text-align: center;
      line-height: 23px;
    }
  }
  .rater-list{
    margin-top: 17px;
    padding:0 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li{
      margin-bottom: 16px;
      width: 163px;
      height: 260px;
      background: #EEF5FF;
      border-radius: 12px;
      border: 1px solid #BAD3FF;
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
      .num{
        position: absolute;
        top:0;
        left:-1px;
        width: 71px;
        height: 19px;
        line-height: 19px;
        text-align: center;
        color:#ffffff;
        font-size:11px;
        background:url('../../assets/images/review/number_bg.png') no-repeat center/71px;
      }
      .avatar{
        margin-top: 21px;
        width: 80px;
        height: 104px;
        position: relative;
        img{
          position: absolute;
          width: 100%;
          height: 100%;
          top:0;
          left:0;
        }
      }
      .name{
        margin-top: 5px;
        text-align: center;
        font-size:16px;
        color:#222222;
        font-weight: 500;
      }
      .group-duty{
        margin-top: 3px;
        padding:0 12px;
        height: 40px;
        text-align: center;
        color:#222222;
        font-size:12px;
        display: flex;
        flex-direction: column;
        align-items: center;
        span{
          width: 140px;
          height: 20px;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .visit{
        margin-top: 8px;
        width: 89px;
        height: 32px;
        line-height: 32px;
        background: linear-gradient(90deg, #8481F2 0%, #2360F9 100%);
        border-radius: 16px;
        text-align: center;
        color:#ffffff;
        font-size:16px;
        &.visited{
          //background: linear-gradient(90deg, #26B0F9 0%, #0146AD 100%);
          //background: linear-gradient(90deg, #26B0F9 0%, #8481F2 100%);
          background: linear-gradient(90deg, #26B0F9 0%, #0CEFE0 100%);
        }
      }
    }
  }
}
</style>